import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import fireAnimationData from '../../assets/animationIcon/fire.json';

export default function LottieFire({ className = 'w-14 h-14 sm:w-16 sm:h-16' }) {
  const containerRef = useRef(null);
  const animInstanceRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    try {
      animInstanceRef.current = lottie.loadAnimation({
        container: containerRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: fireAnimationData
      });
    } catch (err) {
      console.warn('Lottie animation failed to load:', err);
    }

    return () => {
      if (animInstanceRef.current) {
        animInstanceRef.current.destroy();
        animInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`relative flex items-center justify-center overflow-visible pointer-events-none [&>svg]:w-full [&>svg]:h-full [&>svg]:overflow-visible ${className}`}
    />
  );
}
